import { Controller } from "@hotwired/stimulus"

// Manages dress code color motif selection (pick up to MAX colors from palette)
export default class extends Controller {
  static targets = ["chip", "hiddenInputs"]
  toggle(event) {
    const chip = event.currentTarget
    const isSelected = chip.dataset.selected === "true"

    chip.dataset.selected = isSelected ? "false" : "true"
    this.updateChipStyle(chip, !isSelected)

    this.syncHiddenInputs()
  }

  updateChipStyle(chip, selected) {
    if (selected) {
      chip.classList.remove("bg-white", "border-gray-200", "text-gray-700")
      chip.classList.add("bg-teal-50", "border-teal-400", "text-teal-800", "ring-1", "ring-teal-400/30")
    } else {
      chip.classList.remove("bg-teal-50", "border-teal-400", "text-teal-800", "ring-1", "ring-teal-400/30")
      chip.classList.add("bg-white", "border-gray-200", "text-gray-700")
    }
  }

  syncHiddenInputs() {
    const container = this.hiddenInputsTarget
    container.innerHTML = ""

    this.chipTargets
      .filter(c => c.dataset.selected === "true")
      .forEach((chip, index) => {
        const nameInput = document.createElement("input")
        nameInput.type = "hidden"
        nameInput.name = `color_motif[${index}][name]`
        nameInput.value = chip.dataset.colorName

        const hexInput = document.createElement("input")
        hexInput.type = "hidden"
        hexInput.name = `color_motif[${index}][hex]`
        hexInput.value = chip.dataset.colorHex

        container.appendChild(nameInput)
        container.appendChild(hexInput)
      })
  }
}
